import { faqItems } from '@/mocks/comics';

export default function FaqSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">常见问题</h2>
              <p className="text-foreground-500 text-sm max-w-md">关于我们，你可能想知道的</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-colors"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs px-2.5 py-1 bg-accent-100 text-accent-700 font-medium rounded-full">
                    {item.category}
                  </span>
                </div>
                <h3 className="font-heading text-foreground-900 text-base mb-3">{item.question}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}